export default "__VITE_ASSET__03245a5d__"